import "./TermsAndConditions.css";
import heroBg from "../../assets/image/app-store.png";

const TermsConditions = () => {
  return (
    <div className="tc-page">
      {/* HERO */}
      <section
        className="tc-hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="tc-hero-overlay" />
        <div className="tc-hero-content">
          <h1>Terms and Conditions</h1>
        </div>
      </section>

      {/* CONTENT */}
      <div className="tc-container">
        <div className="policy-wrapper">
          <h2>WHAT TYPES OF PERSONAL INFORMATION DO WE COLLECT?</h2>
          <p>
            We collect and generate different types of Personal Information
            depending on how you use or interact with our Services. “Personal
            Information” means information that identifies, describes, or is
            reasonably capable of being associated with you.
          </p>

          <h3>Demographic and Contact Information</h3>
          <p>
            Information you provide to us such as your name, mailing address,
            email address, and telephone or fax number.
          </p>

          <h3>Online or Other Account Information</h3>
          <p>
            Username or email address, passwords, security questions, and other
            information required for account access.
          </p>

          <h3>Webforms and Requests</h3>
          <p>
            Information submitted through online forms including contact
            requests, feedback, newsletters, or inquiries.
          </p>

          <h3>Websites</h3>
          <p>
            Browser type, ISP, referring/exit pages, operating system, date/time
            stamps, and clickstream data.
          </p>

          <h3>Mobile Apps</h3>
          <p>
            Device type, device ID, operating system version, platform used,
            location information, and usage data.
          </p>

          <h3>Device Information</h3>
          <p>
            IP address, hardware model, operating system, unique identifiers,
            and mobile network information.
          </p>

          <h3>Log Information</h3>
          <p>
            Usage details such as visited pages, search terms, clicks, and
            browsing behavior.
          </p>

          <h3>Location Information</h3>
          <p>
            General location derived from IP address, device location, or
            country selection.
          </p>

          <h3>Business Interactions</h3>
          <p>
            Job title, business contact details, product interests, and
            business communications.
          </p>

          <h3>Financial Information</h3>
          <p>
            Payment information necessary to process transactions, securely
            handled by third-party processors such as PayPal.
          </p>

          <h3>Social Media, Forums & Blogs</h3>
          <p>
            Information you submit when interacting with our social media
            pages, forums, or blogs.
          </p>

          <h3>Tracking Technologies</h3>
          <ul>
            <li>Cookies</li>
            <li>Web Beacons</li>
            <li>Tags</li>
            <li>Widgets</li>
            <li>Google Analytics</li>
          </ul>

          <div className="divider" />

          <h2>HOW DO WE USE PERSONAL INFORMATION?</h2>
          <ul>
            <li>To administer and provide Services</li>
            <li>For order fulfillment and delivery</li>
            <li>To manage business transactions</li>
            <li>To respond to inquiries</li>
            <li>To send marketing communications</li>
            <li>To improve products and Services</li>
            <li>To comply with legal obligations</li>
          </ul>

          <div className="divider" />

          <h2>DO WE SHARE PERSONAL INFORMATION WITH THIRD PARTIES?</h2>
          <p>
            We may share personal information with affiliates, service
            providers, payment processors, and authorities as required by law.
          </p>

          <div className="divider" />

          <h2>HOW DO WE SECURE AND RETAIN PERSONAL INFORMATION?</h2>
          <p>
            We use physical, electronic, and administrative safeguards including
            SSL encryption to protect your data.
          </p>

          <div className="divider" />

          <h2>WHAT ARE MY DATA PROTECTION RIGHTS?</h2>
          <ul>
            <li>Right to access</li>
            <li>Right to correct</li>
            <li>Right to delete</li>
            <li>Right to opt-out</li>
            <li>Right to data portability</li>
          </ul>

          <div className="divider" />

          <h2>HOW CAN YOU CONTACT US?</h2>
          <p><strong>Email:</strong> legal@NX.com</p>
          <p><strong>Phone:</strong> +1 (888) 468-9910</p>
          <p>
            <strong>Mail:</strong> NX.com, Inc., 15241 Don Julian Rd,
            City of Industry, CA 91745, USA
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
